function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createSchemaField } from "@formily/react";
import React, { useContext, useEffect, useMemo } from "react";
import { transformMarkupProps } from "../tools";
import DataMapper from "../DataMapper";
import { createFieldModel } from "../../fieldPath";
import { renderSchemaFieldChildren } from "./JsonSchemaField";
function toEasySchemaField(SchemaField, EasySchemaFieldMap, EasySchemaFieldContext, dataMapper, globalScope) {
  const EasySchemaField = (props) => {
    const { form, scope: innerScope, schema, children } = props, baseProps = _object_without_properties(props, [
      "form",
      "scope",
      "schema",
      "children"
    ]);
    dataMapper.clearFormDataMaps(form);
    useEffect(() => () => {
      if (form) {
        dataMapper.clearFormDataMaps(form);
      }
    }, [
      form
    ]);
    const customChildren = useMemo(() => {
      if (children) {
        return children;
      }
      if (schema) {
        return renderSchemaFieldChildren(schema, EasySchemaFieldMap);
      }
    }, [
      schema,
      children
    ]);
    return /* @__PURE__ */ _jsx(EasySchemaFieldContext.Provider, {
      value: {
        form,
        // 合并 createSchemaField 和 SchemaField props 的 scope
        scope: _object_spread({}, globalScope !== null && globalScope !== void 0 ? globalScope : {}, innerScope !== null && innerScope !== void 0 ? innerScope : {}),
        parentInfo: {
          path: createFieldModel(),
          isArrayField: false,
          isRoot: true
        }
      },
      children: /* @__PURE__ */ _jsx(SchemaField, _object_spread_props(_object_spread({
        scope: innerScope
      }, baseProps), {
        children: customChildren
      }))
    });
  };
  EasySchemaField.displayName = SchemaField.displayName;
  return EasySchemaField;
}
function toEasySchemaFieldComponent(SchemaFieldComponent, EasySchemaFieldContext, dataMapper, componentKey, componentPropsMap) {
  const EasySchemaFieldComponent = (props) => {
    const context = useContext(EasySchemaFieldContext);
    const { form } = context;
    const [effects, parentInfo, originProps] = transformMarkupProps(props, componentKey, context, dataMapper, componentPropsMap);
    if (effects) {
      var _form;
      (_form = form) === null || _form === void 0 ? void 0 : _form.addEffects(effects.id, effects.effects);
    }
    return /* @__PURE__ */ _jsx(SchemaFieldComponent, _object_spread_props(_object_spread({}, originProps), {
      children: /* @__PURE__ */ _jsx(EasySchemaFieldContext.Provider, {
        value: _object_spread_props(_object_spread({}, context), {
          parentInfo
        }),
        children: originProps.children
      })
    }));
  };
  EasySchemaFieldComponent.displayName = SchemaFieldComponent.displayName;
  return EasySchemaFieldComponent;
}
const SCHEMA_FIELD_KEYS = [
  "Markup",
  "String",
  "Object",
  "Array",
  "Boolean",
  "Date",
  "DateTime",
  "Void",
  "Number"
];
export function easyCreateSchemaField(options) {
  const SchemaField = createSchemaField(options);
  const context = /* @__PURE__ */ React.createContext({});
  const dataMapper = new DataMapper();
  const EasySchemaFieldMap = {};
  for (const key of SCHEMA_FIELD_KEYS) {
    EasySchemaFieldMap[key] = toEasySchemaFieldComponent(SchemaField[key], context, dataMapper, key, options.componentPropsMap);
  }
  const EasySchemaField = toEasySchemaField(SchemaField, EasySchemaFieldMap, context, dataMapper, options.scope);
  const EasySchemaFieldReturn = EasySchemaField;
  EasySchemaFieldReturn.DataMapper = dataMapper;
  for (const key of SCHEMA_FIELD_KEYS) {
    EasySchemaFieldReturn[key] = EasySchemaFieldMap[key];
  }
  return EasySchemaFieldReturn;
}
